import React from "react";
import { Box } from "@material-ui/core";
import SkeletonGrid from "common/UI/Skeleton/SkeletonGrid";
import SkeletonTitle from "common/UI/Skeleton/SkeletonTitle";

export default function RankingPageSkeleton() {
  return (
    <>
      <Box mt={6} mb={5}>
        <SkeletonGrid col={1} row={1} rowHeight={200} />

        <SkeletonTitle />
        <SkeletonGrid col={1} row={10} rowHeight={10} />
      </Box>
    </>
  );
}
